<template> 
  <div> 
    <div class="page-title flex-row me-3 mt-3"> 
        <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('opening_operations') }}
        </h1> 
        <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
            <li class="breadcrumb-item text-gray-600">
                <a href="#" class="text-gray-600 text-hover-primary">
                    <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                </a>
            </li>  
            <li class="breadcrumb-item text-primary">{{ $t('accounting') }}</li> 
            <li class="breadcrumb-item text-primary">{{ $t('accounting_transaction') }}</li>
            <li class="breadcrumb-item text-gray-600">{{ $t('opening_operations') }}
                <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
            </li>    
        </ul> 
    </div>  
    <div class="content flex-row-fluid mt-4" id="kt_content">  
        <div class="row">       
            <div class="col-lg-12">
                <div class="card mb-6">
                    <div class="card-header border-0 pt-6">
                        <div class="card-title">
                        </div>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(54,'R')">
                                <Popper hover placement="top">
                                    <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                        <i class="bi bi-eraser-fill fs-4"> </i>
                                    </button>
                                    <template #content>
                                        <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                                    </template>
                                </Popper>
                                <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on">
                                    <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                                    <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    <span v-if="!this.isListProgressing"> {{ $t('list_balances') }} </span> 
                                    <span class="indicator-progress" v-if="this.isListProgressing">
                                        {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span> 
                                </button>                        
                            </div>
                            <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                                <div class="fw-bolder me-5">
                                <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                                <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row p-3">
                            <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2 bg-light">
                                <div class="fv-row mb-7 row">    
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('accounting_period') }}</span> 
                                        </label>   
                                        <Select2 v-model="form.period_id" :options="accountingYears" :settings="{ width: '100%' }" @select="onChangeAccountYear($event)" :disabled="this.lists.length > 0"/>  
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-12">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('balance_type') }}</span>
                                        </label>
                                        <Select2 v-model="form.report_type" :options="reportTypeList" :settings="{width: '100%'}"  :disabled="this.lists.length > 0"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div>
                                <!-- Tercih edilen Balance Type'a göre hesap bakiyeleri gelecek -->
                                <!-- Comparative Balance General görüntüsü gelecek . Level 1'ler olmayacak. Background renkleri aynı olack (Accounting Transaction gibi) --> 
                                <!-- Kayıt Kuralı: Balance = 0 olacak -->

                                <!-- Opening için geçerli -->
                                <!-- Kapanıştan alıyorsa -> Önceki dönemde kapatılan kayıtları bul, onları aç. Hep ters kayıt yapılır. Balance debit ise, credit kaydı yapılacak. Sıfırlanması için -->
                                <!-- Accounting Balances -> gördüğü bakiyenin aynısını kaydedecek. Paralel kayıt  -->

                                <!-- Closing -->
                                <!-- Her zaman ters kayıt yapılır -->

                                <!-- Önceki dönemdeki muhasebe planı bu dönemde yoksa kırmızı ile işaretlenecek ve editlenebilecek (Yeni plan kodunu seçeceğiz listeden) -->
                                <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                                            :data-source="lists" 
                                            :allow-column-reordering="true"  
                                            :allow-column-resizing="true" 
                                            :column-auto-width="true" 
                                            :row-alternatin-enabled="true"
                                            :hover-state-enabled="true" 
                                            :show-row-lines="true" 
                                            @row-prepared="onRowPrepared"
                                            @exporting="this.$onExporting($event , 'Opening-Operations-List')"> 
                                            
                                        <DxFilterRow :visible="true"/>
                                        <DxHeaderFilter :visible="true"/>
                                        <DxGroupPanel :visible="true"/>      
                                        <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                        <DxPaging :page-size="100"/>
                                        <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/> 
                                        <DxSearchPanel :visible="true"/>
                                        <DxScrolling
                                            mode="virtual"
                                            row-rendering-mode="virtual"
                                        />
                                        <DxColumn data-field="l2_account_code" :caption="$t('account_code')" header-cell-template="l2-account-code-header" :width="120" cell-template="l2_account_code-cell-template"/> 
                                        <DxColumn data-field="l2_account_name" :caption="$t('account_name')" header-cell-template="l2-account-name-header" cell-template="l2_account_name-cell-template"/> 
                                        <DxColumn data-field="account_code" :caption="$t('account_code')" header-cell-template="account-code-header" :width="120" cell-template="account_code-cell-template"/> 
                                        <DxColumn data-field="account_name" :caption="$t('account_name')" header-cell-template="account-name-header" cell-template="account_name-cell-template"/> 
                                        <DxColumn data-field="balance" :sorting-method="this.$numericSort" :caption="$t('balance')" alignment="right" cell-template="balance-cell-template"/>
                                        <DxColumn data-field="debit_credit" :caption="$t('debit_credit')" cell-template="debit_credit-cell-template" header-cell-template="debit-credit-header"/>
                                        <DxColumn data-field="target_code" :caption="$t('new_account_code')" header-cell-template="new-account-code-header" cell-template="target_code-cell-template"/>
                                        <DxColumn :width="80" cell-template="is-exist-cell-template" :allow-exporting="false"/> 

                                        <template #l2-account-code-header>
                                            <div>{{ $t('account_code_level_2') }}</div>
                                        </template>
                                        <template #l2-account-name-header>
                                            <div>{{ $t('account_name_level_2') }}</div>
                                        </template>
                                        <template #account-code-header>
                                            <div>{{ $t('account_code') }}</div>
                                        </template>
                                        <template #account-name-header>
                                            <div>{{ $t('account_name') }}</div>
                                        </template>
                                        <template #new-account-code-header>
                                            <div>{{ $t('new_account_code') }}</div>
                                        </template>
                                        <template #debit-credit-header>
                                            <div>{{ $t('debit_credit') }}</div>
                                        </template>

                                        <template #l2_account_code-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.l2_account_code }}
                                            </span>
                                        </template>
                                        <template #l2_account_name-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.l2_account_name }}
                                            </span>
                                        </template>
                                        <template #account_code-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.account_code }}
                                            </span>
                                        </template>
                                        <template #account_name-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.account_name }}
                                            </span>
                                        </template>
                                        <template #balance-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.balance }}
                                            </span>
                                        </template>
                                        <template #debit_credit-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.debit_credit }}
                                            </span>
                                        </template>
                                        <template #target_code-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                <small> {{ data.data.target_code }}</small>
                                                <br>
                                                <small>{{ data.data.target_name}} </small>
                                            </span>
                                        </template>
                                        <template #is-exist-cell-template="{ data }"> 
                                            <button class="btn btn-sm p-1 w-100" 
                                                    :class="{ 'btn-success' : data.data.not_exists == 1, 'btn-primary' : data.data.not_exists == 0 }"
                                                    @click="openSelectionModal(data.data)" 
                                                    data-bs-toggle="modal" 
                                                    data-bs-target="#kt_modal_opening_selection" 
                                                    data-kt-menu-trigger="click" 
                                                    data-kt-menu-placement="bottom-end"> 
                                                <span class="fs-7" v-if="data.data.not_exists == 1">{{$t('select')}}</span> 
                                                <span class="fs-7" v-if="data.data.not_exists == 0">{{$t('modify')}}</span> 
                                            </button> 
                                        </template> 

                                        <DxSummary>
                                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="l2_account_code"/>
                                        </DxSummary>
                                </DxDataGrid>
                            </div>
                        </div> 
                    </div>
                </div> 
            </div>
            <div class="col-lg-12">
                <div class="card card-xxl-stretch mb-6">
                    <div class="card-body">
                        <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2">
                            <div class="fv-row mb-7 row">                      
                                <div class="col-lg-2">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('voucher_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.record_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>
                                </div>
                                <div class="col-lg-8">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('description') }}</span>
                                    </label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" name="discount" v-model="form.description">
                                        <div class="input-group-append" v-if="this.descriptionTypeList.length > 0">
                                            <div class="dropdown dropup">
                                                <button class="btn btn-secondary border border-gray-300 dropdown-toggle rounded-start-0" type="button" @click="this.isOpenDescriptionDropdown = !this.isOpenDescriptionDropdown;">
                                                    <i class="bi bi-plus-lg fs-5 fw-boldest"> </i>
                                                </button>
                                                <div class="dropdown-menu px-3 dropdown-menu-end" data-bs-popper="true" :class="{ 'show': this.isOpenDescriptionDropdown }">
                                                    <ul class="mh-250px mb-0 overflow-scroll list-unstyled"> 
                                                        <li v-for="(item, index) in descriptionTypeList" v-bind:key="item">
                                                            <a class="dropdown-item cursor-pointer p-2 mw-500px" @click="onSelectDescription(item)"
                                                                :class="{'text-success': this.form.description == item.description && item.description !== ''}">
                                                                <i class="bi bi-dash fw-boldest" v-if="this.form.description !== item.description"> </i> 
                                                                <i class="bi bi-check-lg fw-boldest text-success" v-if="this.form.description == item.description && item.description !== ''"> </i>
                                                                {{item.text}}  
                                                            </a>
                                                            <div class="separator separator-dashed my-1" v-if="index !== descriptionTypeList.length - 1"></div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('save_provision_for_balance') }}</span>
                                    </label>
                                    <Select2 v-model="this.form.save_provision" :options="this.isSaveBalanceProvisionList" :settings="{ width: '100%' }"/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-12" v-if="this.$isCredentialActive(54,'I')">
                <div class="card card-xxl-stretch mb-6">
                    <div class="card-body">
                        <div class="d-grid gap-2"> 
                            <button class="btn btn-success btn-lg" type="button" @click="attemptSave()" data-kt-indicator="on" :disabled="!this.lists.length > 0"> 
                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                </svg>
                                </span>  
                                <strong v-if="!this.isSaving"> {{ $t('create_opening_voucher') }} </strong> 
                                <span class="indicator-progress" v-if="this.isSaving">
                                    {{ $t('saving-transaction-please-wait') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  

    <!-- HESAP PLANI AÇMA MODALI -->
    <div class="modal fade" id="kt_modal_opening_selection" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content"  >
                <div class="modal-header bg-primary py-3" id="kt_modal_add_user_header">
                    <h2 class="modal-title fw-bolder col-md-10 text-white">
                        {{ $t('accounting_plan_selection') }}
                    </h2>  
                    <div class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" aria-label="Close" ref="closeModal">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y">
                    <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                            :show-borders="true" 
                            :data-source="planList" 
                            :column-auto-width="true" 
                            :row-alternatin-enabled="true"
                            :hover-state-enabled="true" 
                            :show-row-lines="true" > 

                            <DxPaging :page-size="10"/>
                            <DxPager :visible="false" :allowed-page-sizes="pageSizesPlanList" :show-page-size-selector="showPageSizeSelectorPlanList" :show-info="true" :show-navigation-buttons="true"/>  

                            <DxColumn data-field="final_code" cell-template="final_code-cell-template" :caption="$t('plan_code')" header-cell-template="plan-code-header" :width="120"/> 
                            <DxColumn data-field="name" cell-template="name-cell-template" :caption="$t('plan_name')" header-cell-template="plan-name-header"/> 
                            <DxColumn caption="" cell-template="actions-cell-template" :width="90" alignment="center"/> 

                            <template #plan-code-header>
                                <div>{{ $t('plan_code') }}</div>
                            </template>
                            <template #plan-name-header>
                                <div>{{ $t('plan_name') }}</div>
                            </template> 

                            <template #final_code-cell-template="{ data }">
                                <a href="#" class="text-gray-800 text-hover-primary mb-1">
                                    {{ data.data.final_code}}
                                </a>
                            </template>
                            <template #name-cell-template="{ data }">
                                <a href="#" class="text-gray-800 text-hover-primary mb-1">
                                    {{ data.data.name}}
                                </a>
                            </template>
                            <template #actions-cell-template="{ data }">
                                <button class="btn btn-sm btn-success p-1 w-100" @click="onModifyItem(data.data)">
                                    <span class="fs-7">{{ $t('select') }}</span>
                                </button>
                            </template>
                    </DxDataGrid>
                </div>
            </div>
        </div>
    </div>
  </div>  
</template>

<script>
import axios from 'axios' 
import moment from 'moment';

import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxTotalItem, DxSummary, DxScrolling } from 'devextreme-vue/data-grid';



export default {
    name: "OpeningOperationsList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxTotalItem, DxSummary, DxScrolling
    },
	data() {
        return {
            searchbar: '',
            isOpenDescriptionDropdown: false,
            isListProgressing: false,
            isOpenActionsDropdown: false, 
            summary: {},
            lists: [],
            accountingYearList: [],
            accountingYearSelection: null,
            accountingYears: [],
            form:  {
                record_date: moment(), 
                report_type: 1,
                period_id: null,
                periodSelection: {},
                save_provision: 0
            },
            reportTypeList: [
                { id: 1, text: this.$t('accounting_balances_old_period')}, /* Eski yılın hesabından başla. Kapanışı yap */
                { id: 2, text: this.$t('closing_balances_old_period')}, /* Kapanış fişinden al başla */
            ],
            isSaveBalanceProvisionList: [
                { id: 0, text: this.$t('no')},
                { id: 1, text: this.$t('yes')}
            ],
            isAccountingYearLoading: false,
            descriptionTypeList: [],
            temp_session_id: null,
            planList: [],
            accountSelection: null,
            newAccountSelection: null,
            menuSelection : '/OpeningOperationsHelppage',
            iconView : false,
            pagesize: 100,
            pageSizePlanList: 100,
            isSaving: false
        };
  },
  computed: {  
    searchableList() {
      return this.lists.slice((this.page - 1) * this.page_size, this.page * this.page_size);
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    previewOnlyDate(){
        return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
                }
            }
        },
    getReportTypeValue(){
        return (value)=>{
            if (value) {
                return this.reportTypes.find(p => { 
                    return p.id == value;
                }).text; 
            }
        } 
    },
    getPeriodMonthValue(){
        return (value)=>{
            if (value) {
                var period = this.periodList.find(p => { 
                return p.id == value && p.id != '-1';
            }); 
            if(period){
                return period.text;
            }
            else{
                return null;
            }
            }
        } 
    },
    checkIfNewAccountSelected(){
        return this.newAccountSelection == null ? false : true;
    },
    showPageSizeSelector() {
        return this.lists.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.lists.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(1000);
        if(loop > 1) arr.push('all');
        return arr;
    },
    showPageSizeSelectorPlanList() {
        return this.planList.length > this.pageSizePlanList;
    },
    pageSizesPlanList() {
        let arr = [];
        let x = 1;
        let loop = (this.planList.length / this.pageSizePlanList);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSizePlanList * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    }
  },
  methods: { 
    getData() {
        this.lists = [];
        this.planList = [];
        this.accountSelection = null;
        this.newAccountSelection = null;
        const params = {
            session_id: this.$getUser().session_id,
            report_type: this.form.report_type,
            period_id: this.form.period_id
        };
        axios.post('/api/Opening/GetList', params, {'Content-Type': 'application/json'})
        .then((response) => {  
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                this.lists = response.data.data; 
                this.temp_session_id = response.data.temp_session_id; 
            }
            else{
                this.lists = [];
            }
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    getAccountingYears(){
        this.isAccountingYearLoading = true;
        this.companyAccountingPeriods = [];
        const queryParameter = {
            session_id: this.$getUser().session_id
        };
        axios.post('/api/Auth/GetCompanyAccountingYears', queryParameter, {'Content-Type': 'application/json'})
        .then((response) => {   
            this.accountingYears = response.data; 
            this.accountingYears.forEach((period) => {
                if(period.id == this.$getSessionStorage('activeYear')){
                    this.form.period_id = period.id;
                    this.form['periodSelection'] = period; 
                    this.form.record_date = moment(this.form['periodSelection'].start_date); 
                } 
            }); 
            this.getDescriptions();
            setTimeout(() => {
                this.isAccountingYearLoading = false;
            }, 1000); 
        })
        .catch((error) => {
            this.isAccountingYearLoading = false;
            console.error(error);
        }); 
    }, 
    onChangeAccountYear(e){
        this.form['periodSelection'] = e;
        this.form.record_date = this.form['periodSelection'].start_date; 
    },
    setCriteriasToDefault() {   
        this.lists = [];
        this.newAccountSelection = null;
        this.accountSelection = null;
        this.form = {
            record_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'), 
            report_type: 1, 
            period_id: null,
            periodSelection: {},
            save_provision: 0
        };
        this.getAccountingYears();
    },
    createOpeningVoucher(){
        this.isSaving = true;
        const params = {
            session_id: this.$getUser().session_id,
            report_type: this.form.report_type,
            period_id: this.form.period_id,
            save_provision: this.form.save_provision,
            description: this.form.description,
            record_date: moment(this.form.record_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            tmp_session_id: this.temp_session_id
        };
        const that = this;
        axios.post('/api/Opening/Create', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                this.$swal(this.$t('success'), this.$t('opening_voucher_saved_successfully'), 'success');  
                this.setCriteriasToDefault();
            }
            that.isSaving = false;
            this.$Progress.finish();
        })
        .catch((error) => {
            that.isSaving = false;
            console.error(error); 
            this.$Progress.fail();
        });
    },
    getDescriptions() {
        this.isOpenDescriptionDropdown = false;
        const params = {
            session_id: this.$getUser().session_id,
            description_location: 14, // Opening Operations
            location_detail: 0,
            account_type: 0,
            sales_type: 0
        };
        axios.post('/api/Helper/GetDescriptionTypes', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.descriptionTypeList = response.data;
            this.descriptionTypeList.forEach(element => {
                if (element.type_id == 2) {
                    this.form.description = element.description;
                }
            });
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    onSelectDescription(item) {
        this.form.description = item.description;
        this.isOpenDescriptionDropdown = false;
    },
    openSelectionModal(item){ 
        const queryParameter = {
            plan_level: 3,
            accounting_period_id: this.form.period_id,
            session_id: this.$getUser().session_id,
        };  
        axios.post('/api/Helper/GetAccountingPlanByLevel', queryParameter, {'Content-Type': 'application/json'}) 
        .then((response) => {
            this.planList = response.data;
            this.accountSelection = item;
        })
        .catch(() => {
            this.$Progress.finish();
        });
    }, 
    onModifyItem(item){
        const queryParameter = {
            session_id: this.$getUser().session_id,
            temp_session_id: this.temp_session_id,
            source_full_code: this.accountSelection.account_code,
            target_account_id: item.id,
            period_id: this.form.period_id
        };  
        axios.post('/api/Opening/ModifyItem', queryParameter, {'Content-Type': 'application/json'}) 
        .then(() => { 
           this.newAccountSelection = item;
           this.lists.forEach((listItem) => { 
            if(this.accountSelection.account_code == listItem.account_code){
                listItem['target_code'] = item.final_code;
                listItem['target_name'] = item.name;
            }
           });  
           this.$refs.closeModal.click();
        })
        .catch(() => {
            this.$Progress.finish();
        });
    },
    attemptSave(){  
            const params = {
                session_id: this.$getUser().session_id,
                record_date: moment(this.form.record_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                period_id: this.form.period_id
            };
            axios.post('/api/Opening/Check', params, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(response.data == 0){
                        this.$swal.fire({
                            title: this.$t('you_are_about_to_save_1'),
                            confirmButtonColor: "#50cd89",
                            showDenyButton: false,
                            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                            confirmButtonText: this.$t('confirm'),
                            icon: 'info'
                        })
                        .then((result) => {
                            if (result.isConfirmed) {  
                                this.createOpeningVoucher();
                            }
                        });
                }
                if(response.data == 1){
                    // Zaten kaydedilmiş bir Opening Voucher mevcut. Yine de devam etmek istiyor musunuz?  diye sorulur.
                    this.$swal.fire({
                        title: this.$t('an_opening_voucher_already_exists'),
                        confirmButtonColor: "#50cd89",
                        showDenyButton: false,
                        showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                        confirmButtonText: this.$t('yes'),
                        icon: 'warning'
                    })
                    .then((result) => {
                        if (result.isConfirmed) { 
                            this.createOpeningVoucher();
                        }
                    }); 
                }
            })
            .catch((error) => {
                console.error(error);  
            });  
    },
    onRowPrepared(e){
        if(e.rowType === 'data') {
            if(e.data.not_exists == 1) { 
                e.rowElement.classList.add('bg-danger');  
                e.rowElement.classList.add('bg-opacity-10');  
            }  
        } 
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/OpeningOperationsHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
  },
  created() {    
    this.helpPageViewIcon();    
    this.temp_session_id = null;
    this.getAccountingYears();
    this.$removeSessionStorage('record_id');
  },
  mounted(){
    try{ 
        this.form.record_date = moment().subtract((parseInt(this.$getUser().list_date_range)), 'days');
    }
    catch(Err){ console.error(Err);}
  }
}; 
</script>